import { action } from 'easy-peasy';
import { IActionSetHospitalDetails } from '../types';

const setHospitalDetails: IActionSetHospitalDetails = action((state, payload) => {
  state.details = payload;
});

export default setHospitalDetails;
